import helpers from '@debbie/common/dist/economy/helpers/index.js';
import { useCaseVouchersByCase } from '@debbie/cortex/dist/case-vouchers/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import Errors from '../Errors.js';
import Money from '../Money.js';
import { Inline, Pill, Section, SectionLabel } from './shared.js';
const BalanceRow = styled.div `
  font-size: 0.95em;
  color: ${THEME.COLOR_PRIMARY};
  font-weight: 600;
`;
const ConsequenceList = styled.ul `
  margin: 2px 0 0 0;
  padding-left: 16px;
  font-size: 0.85em;

  li {
    margin: 2px 0;
    color: ${THEME.COLOR_PRIMARY};
  }
`;
const EndCaseBody = ({ input, caseId, }) => {
    const lang = useSelector((s) => s.lang);
    const vouchersLoadable = useCaseVouchersByCase(caseId);
    const balance = h.hasData(vouchersLoadable)
        ? helpers.overview.balance(vouchersLoadable.data)
        : null;
    return (React.createElement(React.Fragment, null,
        React.createElement(Section, null,
            React.createElement(Inline, null,
                React.createElement(Pill, null, lang.endReason[input.reason] ?? input.reason))),
        balance != null && (React.createElement(Section, null,
            React.createElement(SectionLabel, null, lang.agentProposalBodies.outstandingBalance),
            React.createElement(BalanceRow, null,
                React.createElement(Money, { amount: balance })))),
        h.isError(vouchersLoadable) && (React.createElement(Errors, { errors: [vouchersLoadable.error.message] })),
        React.createElement(Section, null,
            React.createElement(SectionLabel, null, lang.agentProposalBodies.endCaseConsequences),
            React.createElement(ConsequenceList, null,
                React.createElement("li", null, lang.agentProposalBodies.endCaseConsequencePlans),
                React.createElement("li", null, lang.agentProposalBodies.endCaseConsequenceRki),
                React.createElement("li", null, lang.agentProposalBodies.endCaseConsequenceProposals),
                React.createElement("li", null, lang.agentProposalBodies.endCaseConsequenceFinal)))));
};
export default EndCaseBody;
//# sourceMappingURL=EndCaseBody.js.map